"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Save = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var Save = function (_a) {
    var user = _a.user, channel = _a.channel, id = _a.id;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1];
    var livestreams = ra_fetch_1.useApi('backend').index('livestreams', {
        channel_id: channel.id,
        details: true
    })[0];
    var _c = storybook_1.Helpers.useSave('ecommerce', 'vouchers', {
        id: null,
        name: '',
        description: '',
        type: '',
        start: '',
        end: '',
        limit: null,
        video_id: '',
        user_id: user.id,
        channel_id: channel.id,
        promo_type: null,
        promo_unit: null,
        promo_amount: 0,
    }, { id: id, channel_id: channel.id }), voucher = _c[0], setVoucher = _c[1], submitVoucher = _c[2];
    function onSubmit() {
        submitVoucher().then(function (response) {
            if (!response.errors.length) {
                var modalMessage_1 = id ? 'Je voucher is succesvol aangepast' : 'Je voucher is succesvol aangemaakt';
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: modalMessage_1, returnUrl: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/vouchers" }); }
                });
            }
        });
    }
    if (livestreams.loading || voucher.loading) {
        return react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' });
    }
    if (id && !voucher.data.id) {
        return react_1.default.createElement(storybook_1.Pages.Dashboard.NotFound, null);
    }
    return react_1.default.createElement(storybook_1.Layouts.Container, { type: 'sm', className: 'storybook-layouts-space' },
        react_1.default.createElement(Modal, null),
        react_1.default.createElement(storybook_1.Cards.Card, null,
            react_1.default.createElement(storybook_1.Cards.Content, null,
                react_1.default.createElement(storybook_1.Vouchers.Form, { voucher: voucher.data, setVoucher: setVoucher, livestreams: livestreams.data }),
                react_1.default.createElement(storybook_1.Forms.Buttons, { errors: voucher.errors, loading: voucher.submitting, submit: onSubmit }))));
};
exports.Save = Save;
exports.Save.defaultProps = {
    voucher: {},
};
